import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { lazy, Suspense, type ReactNode } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';
import { Layout } from './components/Layout';
import { LoginPage } from './pages/LoginPage';

// Uma página por pacote: o login e a primeira tela não carregam as outras.
const DashboardPage = lazy(() =>
  import('./pages/DashboardPage').then((module) => ({ default: module.DashboardPage })),
);
const OrdersPage = lazy(() =>
  import('./pages/OrdersPage').then((module) => ({ default: module.OrdersPage })),
);
const PlatformsPage = lazy(() =>
  import('./pages/PlatformsPage').then((module) => ({ default: module.PlatformsPage })),
);
const CostsPage = lazy(() =>
  import('./pages/CostsPage').then((module) => ({ default: module.CostsPage })),
);
const OperationsPage = lazy(() =>
  import('./pages/OperationsPage').then((module) => ({ default: module.OperationsPage })),
);

function RequireAdmin({ children }: { children: ReactNode }) {
  const { admin } = useAuth();
  const location = useLocation();

  return admin === null ? <Navigate to="/login" replace state={{ from: location }} /> : children;
}

function Page({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <Box sx={{ pt: 1 }}>
          <LinearProgress />
        </Box>
      }
    >
      {children}
    </Suspense>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAdmin>
            <Layout />
          </RequireAdmin>
        }
      >
        <Route index element={<Page><DashboardPage /></Page>} />
        <Route path="pedidos" element={<Page><OrdersPage /></Page>} />
        <Route path="plataformas" element={<Page><PlatformsPage /></Page>} />
        <Route path="custos" element={<Page><CostsPage /></Page>} />
        <Route path="operacoes" element={<Page><OperationsPage /></Page>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
